import React from "react";
import { X } from "lucide-react";

const ImageModal = ({ imageUrl, onClose }) => {
    const isVideoUrl = (url) => {
        if (!url) return false;
        return (
            url.toLowerCase().endsWith(".mp4") ||
            url.toLowerCase().endsWith(".mov") ||
            url.toLowerCase().endsWith(".webm") ||
            url.toLowerCase().endsWith(".avi") ||
            /\.(mp4|mov|webm|avi)/i.test(url)
        );
    };

    const handleDownload = async () => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = imageUrl.split("/").pop() || "media";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg max-w-4xl w-full p-8 relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                    <X className="w-6 h-6" />
                </button>
                <button
                    onClick={handleDownload}
                    className="absolute top-4 right-12 text-gray-500 hover:text-gray-700"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                    </svg>
                </button>
                {isVideoUrl(imageUrl) ? (
                    <video
                        src={imageUrl}
                        controls
                        className="w-full h-[500px] object-contain"
                    />
                ) : (
                    <img
                        src={imageUrl}
                        alt="Shared media"
                        className="w-full h-[500px] object-contain"
                    />
                )}
            </div>
        </div>
    );
};

export default ImageModal;
